import { createFileRoute } from "@tanstack/react-router";
import { ProcedureAuthoringScreen } from "../components/procedures/ProcedureAuthoringScreen";

export const Route = createFileRoute("/_app/procedures/authoring")({
  component: ProcedureAuthoringRoute,
  validateSearch: (search: Record<string, unknown>) => ({
    procedureId:
      typeof search.procedureId === "string" ? search.procedureId : undefined,
    aiDraftId:
      typeof search.aiDraftId === "string" ? search.aiDraftId : undefined,
  }),
});

function ProcedureAuthoringRoute() {
  const { procedureId, aiDraftId } = Route.useSearch();
  return (
    <ProcedureAuthoringScreen aiDraftId={aiDraftId} procedureId={procedureId} />
  );
}
